const configProd = {
  apiKey: "AIzaSyCc08JPZvI5yQrBDaTKJ7mUswP4ZnYk7Qk",
  authDomain: "percap-7af8f.firebaseapp.com",
  databaseURL: "https://percap-7af8f.firebaseio.com",
  projectId: "percap-7af8f",
  storageBucket: "percap-7af8f.appspot.com",
  messagingSenderId: "578773196665",
  appId: "1:578773196665:web:9f10d4e17278b5289099a8",
  measurementId: "G-K7161TWF51",

  stripePublicKey: "pk_live_RAAMos9Ic2Xv9XcI9BmnW3Ke00sL2A2aO3",
  baseUrlAlternative: "https://us-central1-percap-7af8f.cloudfunctions.net"
};

const configStaging = {
  apiKey: "AIzaSyDcgqSs2LDOaIrCnO6rp-tylGkegk4uMys",
  authDomain: "percap-staging.firebaseapp.com",
  databaseURL: "https://percap-staging.firebaseio.com",
  projectId: "percap-staging",
  storageBucket: "percap-staging.appspot.com",
  messagingSenderId: "1003984727969",
  appId: "1:1003984727969:web:c2ad9a67c4ed888db365e0",
  measurementId: "G-Q8DVPQQ4C2",

  stripePublicKey: "pk_test_Qndvd240z9RWQRqF1qCjV8t300wzJJtb0x",
  baseUrlAlternative: "https://us-central1-percap-staging.cloudfunctions.net"
};
const configLocal = {
  apiKey: "AIzaSyDcgqSs2LDOaIrCnO6rp-tylGkegk4uMys",
  authDomain: "percap-staging.firebaseapp.com",
  databaseURL: "https://percap-staging.firebaseio.com",
  projectId: "percap-staging",
  storageBucket: "percap-staging.appspot.com",
  messagingSenderId: "1003984727969",
  appId: "1:1003984727969:web:c2ad9a67c4ed888db365e0",
  measurementId: "G-Q8DVPQQ4C2",

  dbSettings: { host: "localhost:8080", ssl: false },
  stripePublicKey: "pk_test_Qndvd240z9RWQRqF1qCjV8t300wzJJtb0x",
  baseUrlAlternative: "http://localhost:5001/percap-staging/us-central1"
};

if (process.env.VUE_APP_ENV == "percap-staging") {
  module.exports = configStaging;
  console.log(`Using staging environment (${process.env.VUE_APP_ENV})`);
} else if (process.env.VUE_APP_ENV == "local") {
  module.exports = configLocal;
  console.log("Using local environment");
} else if (process.env.VUE_APP_ENV == "percap-7af8f") {
  module.exports = configProd;
} else {
  console.log(`WARNING! ENVIRONMENT: ${process.env.VUE_APP_ENV} IS NOT VALID`);
  throw new Error("WARNING! NO VALID ENVIRONMENT SET");
}
